import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: inherit;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  // Flipping arrow to left ← for RTL languages\n  &&:after {\n    content: ' \\2192';\n  }\n\n  [dir='rtl'] &&:after {\n    content: ' \\2190';\n  }\n  [dir='ltr'] &&:after {\n    content: ' \\2192';\n  }\n"
    ], [
        "\n  // Flipping arrow to left ← for RTL languages\n  &&:after {\n    content: ' \\\\2192';\n  }\n\n  [dir='rtl'] &&:after {\n    content: ' \\\\2190';\n  }\n  [dir='ltr'] &&:after {\n    content: ' \\\\2192';\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n      white-space: nowrap;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n  ",
        "\n\n  ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import styled, { css } from "styled-components";
import convertLayoutProps from "../../utils/convertLayoutProps";
import FocusTrap from "../focus-trap/FocusTrap";
import { arrowLinkVariants, colors, resetStyles, sizes, variants } from "./Link.styles";
var isAbsoluteLink = function(href) {
    return href.indexOf("http") === 0;
};
var LinkText = styled.div.withConfig({
    componentId: "sc-e717852e-0"
})(_templateObject());
var LinkArrow = styled.span.withConfig({
    componentId: "sc-e717852e-1"
})(_templateObject1());
var BaseLink = /*#__PURE__*/ React.forwardRef(function(props, ref) {
    var href = props.href, children = props.children, _target = props.target, target = _target === void 0 ? href && isAbsoluteLink(href) ? "_blank" : undefined : _target, _withArrow = props.withArrow, withArrow = _withArrow === void 0 ? false : _withArrow, className = props.className, restProps = _object_without_properties(props, [
        "href",
        "children",
        "target",
        "withArrow",
        "className"
    ]);
    var linkContents = children;
    if (withArrow) {
        linkContents = /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(LinkText, {
                    className: "link-text",
                    children: children
                }),
                /*#__PURE__*/ _jsx(LinkArrow, {
                    className: "link-arrow",
                    "aria-hidden": "true"
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx("a", _object_spread_props(_object_spread({
        ref: ref,
        target: target,
        href: href,
        className: "".concat(className, " js__event-link")
    }, restProps), {
        children: /*#__PURE__*/ _jsx(FocusTrap, {
            as: "span",
            children: linkContents
        })
    }));
});
BaseLink.displayName = "BaseLink";
/**
 * If you need Link that supports styling according to our design tokens
 */ var Link = styled(BaseLink).withConfig({
    componentId: "sc-e717852e-2"
})(_templateObject3(), function(props) {
    return props.theme.normalizeStyles(resetStyles);
}, function(param) {
    var theme = param.theme, $variant = param.$variant, withArrow = param.withArrow;
    return $variant && (withArrow ? theme.expandVariants($variant, arrowLinkVariants) : theme.expandVariants($variant, variants));
}, function(param) {
    var theme = param.theme, $size = param.$size;
    return $size && theme.expandVariants($size, sizes);
}, function(param) {
    var theme = param.theme, $color = param.$color;
    return $color && theme.expandVariants($color, colors);
}, function(_param) {
    var theme = _param.theme, $styles = _param.$styles, props = _object_without_properties(_param, [
        "theme",
        "$styles"
    ]);
    return theme.normalizeStyles(_object_spread({}, convertLayoutProps(props), $styles));
}, function(param) {
    var $nowrap = param.$nowrap;
    return $nowrap && css(_templateObject2());
});
Link.displayName = "Link";
export default Link;
